export const subheadingStyles = {
  fontSize: 'md',
  fontWeight: 'normal',
  mt: ['16px', '16px', '0'],
  pb: '24px',
};

export const trialTitleStyles = {
  fontSize: '3xl',
  fontWeight: 'semibold',
  mb: '16px',
};

export const trialButtonStyles = {
  borderRadius: '10px',
  fontSize: '17px',
  height: '40px',
  mt: '32px',
  padding: '7px 16px',
  sx: { _disabled: { opacity: 1 } },
  textShadow: '0 1px 1px rgba(0, 0, 0, 0.08)',
};

export const contentBoxMobileProps = {
  borderRadius: '0',
  boxShadow: 'none',
  position: 'relative',
  top: '0',
  transform: 'none',
  width: '100%',
};

export const titleStyles = {
  fontSize: '3xl',
  fontWeight: 'semibold',
  paddingBottom: ['0', '0', '16px'],
  pt: '0',
};

export const autocompleteResultsWrapperStyles = {
  borderRadius: '12px',
  boxShadow:
    '0 0 0 0.5px rgba(18, 21, 26, 0.08), 0 4px 8px rgba(18, 21, 26, 0.04), 0 8px 16px -2px rgba(18, 21, 26, 0.04),0 16px 32px -4px rgba(18, 21, 26, 0.04)',
  minWidth: '100%',
  maxWidth: '400px',
  position: 'relative',
  sx: { img: { height: '14px' } },
  width: ['89%', '89%', 'auto'],
  maxHeight: '190px',
  overflow: 'auto',
};

export const businessWrapperStyles = {
  maxWidth: '400px',
};

export const enterManuallyButtonProps = {
  color: 'silver.lightest',
  variant: 'primary',
  size: 'sm',
  padding: '4px 8px',
};

export const businessFieldIconProps = {
  iconProps: {
    icon: 'Search',
    fillColor: 'black.lighter',
    size: 'sm',
    side: 'left',
  },
};
